export const DEFAULT_PROSODY_RATE = 3;
